<app-link [to]="to">
  <div class="card-product -title">
    @if (icon) {
    <lucide-icon [name]="icon" size="32"></lucide-icon>
    }
    <h3>{{ title }}</h3>
  </div>
  <ng-content></ng-content>
</app-link>
